import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const DeleteConfirmationModal = ({ isOpen, onConfirm, onCancel, messageTranslationKey }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{t("aicontrol.header.confirmAction")}</ModalHeader>
      <ModalBody>
        {t(messageTranslationKey || "aicontrol.message.delete")}
      </ModalBody>
      <ModalFooter className="mb-3" style={{ justifyContent: 'center' }}>
        <Button color="danger" onClick={onConfirm} aria-label={t("Delete")} className="me-2"><FontAwesomeIcon icon={faTrash} /></Button>
        <Button color="secondary" onClick={onCancel} aria-label={t("Cancel")}><FontAwesomeIcon icon={faTimes} /></Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmationModal;
